<template>
    <footer
        class="bg-secondary"
    >
        <div
            class="max-w-[1200px] py-16 px-12 xl:px-6 mx-auto
                flex flex-col md:flex-row md:items-center md:justify-between gap-10"
        >
            <div>
                <ul
                    class="flex flex-col gap-4 md:flex-row md:gap-8"
                >
                    <li v-for="item in footerNavItems" :key="item.text">
                        <component
                            :is="item.component"
                            v-bind="item.component === 'a' ? { href: item.href } : { to: item.href }"
                            class="text-white transition-colors duration-200 hover:text-alto"
                            :target="item.component === 'a' ? '_blank' : '_self'"
                            @click="handleContactClick"
                        >
                            {{ item.text }}
                        </component>
                    </li>
                </ul>
            </div>
  
            <div class="flex flex-row">
                <a
                    href="https://linkedin.com/company/big-leap-health"
                    target="_blank"
                    class="transition-transform duration-200 hover:scale-110"
                >
                    <component :is="LinkedInIcon" class="h-8 w-8" />
                </a>
            </div>
  
        </div>
    </footer>
</template>
  
<script setup lang="ts">
import LinkedInIcon from "~/assets/images/icons/linkedin.svg";

const text = "Contact";
const href = "https://calendly.com/yakovkagan/30min";

const handleContactClick = () => {
  // Analytics can be added later when the utils file exists
  console.log('Contact clicked');
};

const footerNavItems = [
  {
      component: 'a',
      href: 'https://bigleaphealth.com/terms-of-use',
      text: 'Terms of Service',
  },
  {
      component: 'a',
      href: 'https://bigleaphealth.com/privacy-policy',
      text: 'Privacy Policy',
  },
  {
      component: 'a',
      href,
      text,
  }
]
</script>
